import tripadvisorMetaMetrics from "./metasearchMetrics/tripadvisor-meta/tripadvisorMetaMetrics";
import tripadvisorSpMetrics from "./metasearchMetrics/tripadvisor-sp/tripadvisorSpMetrics";
import googleHotelAdsMetrics from "./metasearchMetrics/google-hotel-ads/googleHotelAdsMetrics";
import googleHotelAdsMetricsFbl from "./metasearchMetrics/google-hotel-ads-fbl/googleHotelAdsMetricsFbl";
import skyscannerMetrics from "./metasearchMetrics/skyscanner/skyscannerMetrics";
import trivagoMetaMetrics from "./metasearchMetrics/trivago-meta/trivagoMetaMetrics";
import kayakMetrics from "./metasearchMetrics/kayak/kayakMetrics";
import wegoMetrics from "./metasearchMetrics/wego/wegoMetrics";
import bingHotelAdsMetrics from "./metasearchMetrics/bing-hotel-ads/bingHotelAdsMetrics";
import trivagoSLMetrics from "./metasearchMetrics/trivago-sl/trivagoSLMetrics";
import googleHotelAdsPPAMetrics from "./metasearchMetrics/google-hotel-ads-ppa/googleHotelAdsPPAMetrics";
import allMetrics from "./ListMetrics";

export const metricsMap = {
    tripadvisor: tripadvisorMetaMetrics,
    tripadvisorSponsoredPlacement: tripadvisorSpMetrics,
    googlehotelads: googleHotelAdsMetrics,
    googleHotelAdsFBL: googleHotelAdsMetricsFbl,
    googleHotelAdsPropertyPromotionAds: googleHotelAdsPPAMetrics,
    skyScanner: skyscannerMetrics,
    trivago: trivagoMetaMetrics,
    trivagoSponsoredListing: trivagoSLMetrics,
    kayak: kayakMetrics,
    wego: wegoMetrics,
    bing: bingHotelAdsMetrics,
    bingPropertyPromotionAds: bingHotelAdsMetrics,
};

export function getMetricsByPlatform(platform = []) {
    // if no platform slected
    if (!platform.length) {
        return allMetrics
    }

    // if one selected platform
    if (platform.length === 1) {
        const singlePlatformId = platform?.[0]?.id;
        return metricsMap[singlePlatformId] || allMetrics;
    }

    // if multiple platforms but all google
    if (platform.every((pl) => pl.label.toLowerCase().includes("google"))) {
        // all google, fusion
        return [
            ...metricsMap["googlehotelads"],
            ...metricsMap["googleHotelAdsFBL"],
            ...metricsMap["googleHotelAdsPropertyPromotionAds"],
        ];
    } else if (platform.every((pl) => pl.label.toLowerCase().includes("trivago"))) {
        // all trivago, fusion
        return [
            ...metricsMap["trivago"],
            ...metricsMap["trivagoSponsoredListing"],
        ];
    } else if (platform.every((pl) => pl.label.toLowerCase().includes("tripadvisor"))) {
        // all trip, fusion
        return [
            ...metricsMap["tripadvisor"],
            ...metricsMap["tripadvisorSponsoredPlacement"],
        ];
    }

    // sinn on retourne tout
    return allMetrics;
}

export default metricsMap;
